// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"343":"59db7ce4","951":"3e990d44"}[chunkId] + ".css";
};